import { rankingList } from "@/mocks/creatorDirectory";

export default function Ranking() {
  return (
    <section id="ranking" className="w-full bg-secondary-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-5xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-trophy-line"></i>
            编辑精选榜
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            值得优先了解的 8 位创作者
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            这是一份按内容领域影响力与辨识度整理的编辑视角榜单，用来帮你决定“从谁开始看”。
            它不是平台官方排名，名次仅作参考，重点在于每位创作者擅长的方向。
          </p>
        </div>

        <ol className="mt-10 space-y-3 md:space-y-4">
          {rankingList.map((item) => (
            <li
              key={item.rank}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300 md:flex-row md:items-center md:gap-6 md:p-6"
            >
              <div className="flex items-center gap-4 md:w-16 md:flex-col md:gap-1">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg font-heading text-lg font-bold ${
                    item.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <i className={`${item.medal} text-xl text-accent-600 md:text-lg`}></i>
              </div>

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{item.name}</h3>
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-medium text-primary-700">
                    {item.category}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.reason}</p>
              </div>

              <div className="flex flex-wrap gap-1.5 md:justify-end">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-1 text-[11px] text-secondary-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-7 text-center text-xs text-foreground-500">
          <i className="ri-error-warning-line mr-1.5"></i>
          榜单依据内容领域结构与长期表现整理，账号热度会持续变化，请以平台实时信息为准。
        </p>
      </div>
    </section>
  );
}